import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Checkbox as CoreCheckbox, type CheckboxProps as CoreCheckboxProps } from '@vox/frontend-react-ui';
import { Checkbox as PrimeCheckbox } from 'primereact/checkbox';

type CheckboxProps = Omit<CoreCheckboxProps,
    'renderInput' | 'defaultChecked' | 'onChange' | 'children' | 'error' | 'classNames'
> & { checked: boolean };

/** Показывает флажок в оформлении Manage */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
    props,
    ref,
) {
    const control = useRef<PrimeCheckbox>(null);

    useImperativeHandle<HTMLInputElement | null, HTMLInputElement | null>(
        ref,
        () => control.current?.getInput() ?? null,
        [],
    );

    return <CoreCheckbox
        {...props}
        renderInput={(input, changeChecked) => <PrimeCheckbox
            ref={control}
            inputId={input.id}
            inputRef={input.ref}
            name={input.name}
            value={input.value}
            checked={Boolean(input.checked)}
            onChange={event => changeChecked(Boolean(event.checked))}
            onBlur={input.onBlur}
            onFocus={input.onFocus}
            disabled={input.disabled}
            required={input.required}
            readOnly={input.readOnly}
            tabIndex={input.tabIndex}
            className={input.className}
            invalid={Boolean(input['aria-invalid']) && input['aria-invalid'] !== 'false'}
            aria-invalid={input['aria-invalid']}
            aria-describedby={input['aria-describedby']}
            aria-label={input['aria-label']}
            aria-labelledby={input['aria-labelledby']}
        />}
    />;
});
